import { Component } from 'react';
import { WarningCircle, ArrowClockwise } from '@phosphor-icons/react';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex items-center justify-center min-h-[300px] p-8" data-testid="error-boundary">
          <div className="text-center max-w-md">
            <WarningCircle size={36} className="mx-auto mb-4 text-kova-red" />
            <h2 className="font-heading text-lg font-bold text-kova-white mb-2">Something went wrong</h2>
            <p className="text-kova-silv text-sm mb-4">
              {this.state.error?.message || 'An unexpected error occurred.'}
            </p>
            <button
              onClick={() => { this.setState({ hasError: false, error: null }); window.location.reload(); }}
              className="inline-flex items-center gap-2 font-mono text-[10px] tracking-[2px] uppercase bg-kova-cyan text-kova-bg px-4 py-2 hover:bg-kova-cyan2 transition-colors cursor-crosshair"
              data-testid="error-retry-btn"
            >
              <ArrowClockwise size={14} />
              Reload Page
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
